export const viconSVGHelper = (rawSvg: string, degree?: number) => {
  return {
    render: () => h('span', {
      innerHTML: rawSvg,
      style: `display: inline-flex; align-items: center; justify-content: center; ${
        degree ? `transform: rotate(${degree}deg);` : ''
      }`,
    }),
  }
}
